import React from 'react';

import type { CustomizationDeliveryScreenProps } from '../../navigation/AppNavigation.props';
import { DeliveryCustomization } from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDeliveryScreen = (
  props: CustomizationDeliveryScreenProps,
) => {
  const { navigation, route } = props;

  const { addressId, productSlug, reorderLineItemId } = route.params ?? {};

  // ─── Helpers ─────────────────────────────────────────────────────────

  const handleAddLineItemToCart = React.useCallback(() => {
    navigation.replace('Bag', { referrer: 'DeliveryMenu' });
  }, [navigation]);

  // ─────────────────────────────────────────────────────────────────────

  return (
    <DeliveryCustomization
      addressId={addressId}
      productSlug={productSlug}
      reorderLineItemId={reorderLineItemId}
      onAddLineItemToCart={handleAddLineItemToCart}
      isEditProductMode={false}
    />
  );
};
